import { mapGetters } from 'vuex';

const description = {
  computed: {
    ...mapGetters('pref', ['getLang']),
  },
  methods: {
    description(obj) {
      if (obj[`description_${this.getLang}`] === undefined) {
        return obj.description_eng || obj.description_pl;
      }

      return obj[`description_${this.getLang}`];
    },
  },
};

export default description;
